const TYPES_OEXT = {
  odt: "application/vnd.oasis.opendocument.text",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  pdf: "application/pdf",
};
const IMAGEN_PRODUCT_DEFAULT =
  "https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg";

export { TYPES_OEXT, IMAGEN_PRODUCT_DEFAULT };
